var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getTrackOrderIngressWidgetStyles } from './TrackOrderIngressWidgetStyles';
import { BLACK_700, BLACK_900, Button, Card, Typography, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { Image, View } from 'react-native';
export var TrackOrderIngressWidgetComponent = props => {
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var trackOrderIngressWidgetStyles = getTrackOrderIngressWidgetStyles(isLargeScreen);
  var id = props.id,
    heading = props.heading,
    subHeading = props.subHeading,
    showCta = props.showCta,
    onPressCta = props.onPressCta,
    imageUrl = props.imageUrl,
    imageStyle = props.imageStyle,
    ctaTitle = props.ctaTitle,
    onUserAction = props.onUserAction,
    style = props.style,
    childStyle = props.childStyle,
    _props$buttonType = props.buttonType,
    buttonType = _props$buttonType === void 0 ? 'secondary' : _props$buttonType,
    _props$accessibilityP = props.accessibilityProps,
    accessibilityProps = _props$accessibilityP === void 0 ? {} : _props$accessibilityP,
    accessibilityHeadingLabel = props.accessibilityHeadingLabel,
    restProps = __rest(props, ["id", "heading", "subHeading", "showCta", "onPressCta", "imageUrl", "imageStyle", "ctaTitle", "onUserAction", "style", "childStyle", "buttonType", "accessibilityProps", "accessibilityHeadingLabel"]);
  var hideUI = !heading && !subHeading && !imageUrl;
  if (hideUI) return null;
  return _jsxs(Card, Object.assign({
    style: [trackOrderIngressWidgetStyles.container, style]
  }, restProps, {
    children: [_jsxs(View, Object.assign({
      style: [trackOrderIngressWidgetStyles.subContainer, childStyle]
    }, {
      children: [!!heading && _jsx(Typography, Object.assign({
        type: isLargeScreen ? 'body-para-md-bold' : 'body-para-sm-bold',
        text: heading,
        color: BLACK_900,
        accessibilityLabel: accessibilityHeadingLabel
      }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'heading'))), !!subHeading && _jsx(Typography, Object.assign({
        type: isLargeScreen ? 'body-para-sm' : 'body-para-xs',
        text: subHeading,
        color: BLACK_700,
        style: trackOrderIngressWidgetStyles === null || trackOrderIngressWidgetStyles === void 0 ? void 0 : trackOrderIngressWidgetStyles.subHeading
      }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'subHeading'))), !!showCta && _jsx(Button, Object.assign({
        buttonType: buttonType,
        title: ctaTitle,
        onPress: () => onPressCta && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onPressCta), Object.assign({}, props)))
      }, accessibilityProps, {
        style: trackOrderIngressWidgetStyles.ctaButton
      }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'ctaTitle')))]
    })), !!imageUrl && _jsx(Image, {
      source: {
        uri: imageUrl
      },
      style: [trackOrderIngressWidgetStyles.trackImage, imageStyle],
      resizeMode: "contain"
    })]
  }));
};
TrackOrderIngressWidgetComponent.genericRendererKey = 'AirTrackOrderIngressWidget';